import React, { FC } from 'react';

import GeneralLayout from 'core/react/layout/GeneralLayout';
import { VehiclesMonitoring } from 'components/organisms/vehicles-monitoring';

export const VehiclesMonitoringPage: FC = () => (
  <GeneralLayout>
    <VehiclesMonitoring />
  </GeneralLayout>
);
